import { Navigate, useNavigate, useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import Home from "../../pages/home/pg-home";
import Footer from "../../components/footer-tab/fixedfooter";
import HeaderHome from "../../components/header-tab/fixed-header-home";
import ProductList from "../../pages/home/pg-product-list";
import HeaderCommon from "../../components/header-tab/fixed-common-header";
import Startup from "../../pages/home/pg-startup";
import Product from "../../pages/home/pg-product";
import FilterOutletsProducts from "../../pages/home/pg-filter-outlets-products";
import CategoryWiseMerchant from "../../pages/home/pg-merchants-to-mobile-app-category.js";
import MasterCategory from "../../pages/home/pg-master-category";
import Landing from "../../pages/home/pg-landing";
import Settings from "../../pages/home/pg-settings.js";
import Configure from "../../pages/home/pg-configure.js";
import PromoProductList from "../../pages/home/pg-promo-product-list.js";
import TypeLanding from "../../pages/home/pg-type-landing.js";
import QRList from "../../pages/home/pg-qr-product-list.js";
import { CSP, ENCRYPT_STORAGE } from "../../config/config";
import { ENTRY_MODE, MID, TABLE_NO } from "../../database/store-names";

const normalizeQrSegment = (value) =>
  String(value || "")
    .trim()
    .replace(/^mid=/i, "");

const buildQrListPath = (mid, tableNo) => {
  const normalizedMid = normalizeQrSegment(mid);
  const normalizedTableNo = String(tableNo || "").trim();

  if (normalizedTableNo === "" || normalizedTableNo === "0") {
    return `/qr-list/${normalizedMid}`;
  }

  return `/qr-list/${normalizedMid}/${normalizedTableNo}`;
};

export function RTStartup(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <Startup navigate={navigate} params={params} />
    </>
  );
}

export function RTSettings(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <Settings navigate={navigate} params={params} />
    </>
  );
}

export function RTConfigure(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <Configure navigate={navigate} params={params} />
    </>
  );
}

export function RTLand(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <Landing navigate={navigate} params={params} />
    </>
  );
}

export function RTTypeLand(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <TypeLanding navigate={navigate} params={params} />
    </>
  );
}

export function RTHome(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderHome navigate={navigate} params={params} />
      <Home navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTPromoProductList(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <PromoProductList navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTQRProductList(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <QRList navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTProductList(props) {
  const navigate = useNavigate();
  const params = useParams();
  const isDtQr = CSP === "DT" && ENCRYPT_STORAGE.getItem(ENTRY_MODE) === "QR";

  if (isDtQr) {
    const qrMid = normalizeQrSegment(
      ENCRYPT_STORAGE.getItem(MID) || params.mid || params.pid || "",
    );
    const qrTableNo = String(
      ENCRYPT_STORAGE.getItem(TABLE_NO) || params.tableNo || "",
    ).trim();
    return (
      <Navigate
        to={buildQrListPath(qrMid, qrTableNo)}
        replace
      />
    );
  }

  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <ProductList navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTProduct(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <Product navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTOutletsProduct(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <FilterOutletsProducts navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTMasterCategory(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <MasterCategory navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}

export function RTCategoryWiseMerchant(props) {
  const navigate = useNavigate();
  const params = useParams();
  return (
    <>
      <ToastContainer />
      <HeaderCommon navigate={navigate} params={params} />
      <CategoryWiseMerchant navigate={navigate} params={params} />
      <Footer navigate={navigate} params={params} />
    </>
  );
}
